import * as yup from 'yup';

export const MultiPageImportValidationSchema = yup.object().shape({
    file: yup.mixed().test(
        'fileIsRequired',
        'File is required',
        function (item) {
            return (this.parent.file != undefined && this.parent.file.size > 0)
        }
    ),
    selectedImportTypes: yup
        .array()
        .test(
            'importTypesRequired',
            'Please select at least one sheet to import',
            function (item) {
                return ((item !== undefined && item.length > 0))
            }
        )
});
